export const CACHE_KEY_LIST_CNAE_NOMENCLATOR = 'CNAENomenclators';
export const CACHE_KEY_CNAE_NOMENCLATOR = 'CNAENomenclator-one';
export const ROUTE_PATH_CNAE_NOMENCLATOR = '/configuration/cnae-nomenclators';
export const TRANSLATION_PREFIX_CNAE_NOMENCLATOR = 'CNAENomenclator';
export const SECURITY_KEY_CNAE_NOMENCLATOR = 'CNAE_ACTIVITY';

export const CNAE_ACTIVE_APPEARANCE = {
  ACTIVATE: {color: 'green'},
  DEACTIVATE: {color: 'red'},
};

export const CNAE_ALLOW_APPEARANCE = {
  ALLOW: {color: 'green'},
  PROHIBIT: {color: 'red'},
};
